export default __webpack_public_path__ + "static/waldverband vorarlberg logo-1d1b375b2d9a0d3b928d48f03cc0f733.jpg";